import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, Table, TableHead, TableBody, TableRow, TableCell,
  TableContainer, Button, TextField, InputAdornment, Switch, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions, Grid, Snackbar, Alert, Chip
} from '@mui/material';
import { Add, Search, Edit, Delete } from '@mui/icons-material';
import { countriesAPI } from '../../services/api';

var BLANK = { name: '', iso2: '', dial_code: '', is_active: true, sort_order: 0 };

export default function CountrySettings() {
  var ls = useState([]); var list = ls[0]; var setList = ls[1];
  var qs = useState(''); var query = qs[0]; var setQuery = qs[1];
  var es = useState(null); var editing = es[0]; var setEditing = es[1];
  var ts = useState(''); var toast = ts[0]; var setToast = ts[1];
  var bs = useState(false); var busy = bs[0]; var setBusy = bs[1];

  function load() {
    countriesAPI.list().then(function(r) { setList(r.data.data || []); });
  }
  useEffect(load, []);

  function save() {
    var payload = {
      name: editing.name,
      iso2: editing.iso2,
      dial_code: editing.dial_code,
      is_active: !!editing.is_active,
      sort_order: parseInt(editing.sort_order, 10) || 0,
    };
    setBusy(true);
    var req = editing.id ? countriesAPI.update(editing.id, payload) : countriesAPI.create(payload);
    req.then(function() {
      setToast(editing.id ? 'Country saved' : 'Country added');
      setEditing(null); load();
    }).catch(function(e) {
      setToast((e.response && e.response.data && e.response.data.error) || 'Could not save');
    }).then(function() { setBusy(false); });
  }

  function toggleActive(c) {
    countriesAPI.update(c.id, {
      name: c.name, iso2: c.iso2, dial_code: c.dial_code,
      is_active: !c.is_active, sort_order: c.sort_order,
    }).then(function() {
      setToast(c.is_active ? c.name + ' hidden from forms' : c.name + ' shown on forms');
      load();
    }).catch(function() { setToast('Could not update'); });
  }

  function remove(c) {
    if (!window.confirm('Remove ' + c.name + ' from the list? Applications that already recorded it keep their answer. Hiding it instead is usually safer.')) return;
    countriesAPI.remove(c.id).then(function() { setToast(c.name + ' removed'); load(); })
      .catch(function() { setToast('Could not remove'); });
  }

  var filtered = list.filter(function(c) {
    if (!query) return true;
    var hay = (c.name + ' ' + (c.iso2 || '') + ' ' + (c.dial_code || '')).toLowerCase();
    return hay.indexOf(query.toLowerCase()) >= 0;
  });
  var activeCount = list.filter(function(c) { return c.is_active; }).length;

  var E = React.createElement;

  return E(Box, null,
    E(Box, {sx:{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:1, mb:1}},
      E(Typography, {variant:'h4'}, 'Countries'),
      E(Button, {variant:'contained', startIcon:E(Add),
        onClick:function(){ setEditing(Object.assign({}, BLANK)); }}, 'Add country')),
    E(Typography, {variant:'body2', color:'text.secondary', sx:{mb:3}},
      'This list fills the Country field and the dialling-code picker on phone fields, across every form. ' +
      activeCount + ' of ' + list.length + ' entries are shown to applicants.'),

    E(TextField, {size:'small', placeholder:'Search name, ISO code or dialling code', value:query,
      onChange:function(e){ setQuery(e.target.value); }, sx:{mb:2, width:'100%', maxWidth:420},
      InputProps:{startAdornment:E(InputAdornment, {position:'start'}, E(Search, {fontSize:'small'}))}}),

    E(Card, null,
      E(TableContainer, null,
        E(Table, {size:'small'},
          E(TableHead, null,
            E(TableRow, null,
              E(TableCell, null, 'Name'),
              E(TableCell, null, 'ISO'),
              E(TableCell, null, 'Dialling code'),
              E(TableCell, null, 'Order'),
              E(TableCell, null, 'Shown on forms'),
              E(TableCell, {align:'right'}, 'Actions'))),
          E(TableBody, null,
            filtered.map(function(c) {
              return E(TableRow, {key:c.id, hover:true},
                E(TableCell, null, c.name),
                E(TableCell, null, c.iso2 ? E(Chip, {label:c.iso2, size:'small', variant:'outlined'}) : '\u2014'),
                E(TableCell, null, c.dial_code || '\u2014'),
                E(TableCell, null, c.sort_order || 0),
                E(TableCell, null,
                  E(Switch, {size:'small', checked:!!c.is_active, onChange:function(){ toggleActive(c); }})),
                E(TableCell, {align:'right'},
                  E(IconButton, {size:'small', onClick:function(){ setEditing(Object.assign({}, c)); }},
                    E(Edit, {fontSize:'small'})),
                  E(IconButton, {size:'small', color:'error', onClick:function(){ remove(c); }},
                    E(Delete, {fontSize:'small'}))));
            }),
            filtered.length === 0 ? E(TableRow, null,
              E(TableCell, {colSpan:6, align:'center', sx:{py:4, color:'text.secondary'}},
                'Nothing matches that search.')) : null)))),

    editing ? E(Dialog, {open:true, onClose:function(){ setEditing(null); }, maxWidth:'sm', fullWidth:true},
      E(DialogTitle, null, editing.id ? 'Edit country' : 'Add country'),
      E(DialogContent, {sx:{pt:'16px !important'}},
        E(Grid, {container:true, spacing:2},
          E(Grid, {item:true, xs:12},
            E(TextField, {fullWidth:true, label:'Name', value:editing.name, autoFocus:true,
              helperText:'Exactly as it should appear in the dropdown',
              onChange:function(e){ setEditing(Object.assign({}, editing, {name:e.target.value})); }})),
          E(Grid, {item:true, xs:6},
            E(TextField, {fullWidth:true, label:'ISO code', value:editing.iso2 || '', placeholder:'HK',
              inputProps:{maxLength:2},
              onChange:function(e){ setEditing(Object.assign({}, editing, {iso2:e.target.value.toUpperCase()})); }})),
          E(Grid, {item:true, xs:6},
            E(TextField, {fullWidth:true, label:'Dialling code', value:editing.dial_code || '', placeholder:'+852',
              onChange:function(e){ setEditing(Object.assign({}, editing, {dial_code:e.target.value})); }})),
          E(Grid, {item:true, xs:6},
            E(TextField, {fullWidth:true, type:'number', label:'Sort order', value:editing.sort_order || 0,
              helperText:'0 sorts alphabetically; use a negative number to pin to the top',
              onChange:function(e){ setEditing(Object.assign({}, editing, {sort_order:e.target.value})); }})),
          E(Grid, {item:true, xs:6, sx:{display:'flex', alignItems:'center'}},
            E(Box, {sx:{display:'flex', alignItems:'center', gap:1}},
              E(Switch, {checked:!!editing.is_active,
                onChange:function(e){ setEditing(Object.assign({}, editing, {is_active:e.target.checked})); }}),
              E(Typography, {variant:'body2'}, 'Shown on forms'))))),
      E(DialogActions, null,
        E(Button, {onClick:function(){ setEditing(null); }}, 'Cancel'),
        E(Button, {variant:'contained', onClick:save, disabled:busy || !editing.name.trim()},
          editing.id ? 'Save changes' : 'Add country'))) : null,

    E(Snackbar, {open:!!toast, autoHideDuration:3000, onClose:function(){ setToast(''); }},
      E(Alert, {severity:'info', onClose:function(){ setToast(''); }}, toast)));
}
